import { Box, Grid, Typography } from "@material-ui/core";
import OrganizationEmployeePagesForm from "./organizationEmployeePagesForm";

export default function OrganizationEmployeeEditPage({ disabled, ...props }) {
  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Organization &gt; Edit Employee 
        </Typography>
      </Box>
      <Grid container xs={6}>
        <OrganizationEmployeePagesForm
          description="Edit Employee"
          submitBtnTxt="Save Changes"
          upperBtnEmployeeSize="50%"
          history={props.history}
          disabled={disabled}
        />
      </Grid>
    </>
  );
}
